import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../grid/grid';
import '../typography/typography';
import css from './breadcrumb.css';

const renderLink = (href, name) => (
  <a href={href} className={css['ds-breadcrumb__link']}>
    <span>{name}</span>
  </a>
);

const renderCurrentLocation = (href, name) => (
  <a
    href={href}
    className={`${css['ds-breadcrumb__link']} ${
      css['ds-breadcrumb__link--current']
    }`}
    aria-current='page'
  >
    <span>{name}</span>
  </a>
);

const Breadcrumb = ({ items }) => (
  <nav className={css['ds-breadcrumb']} aria-label='breadcrumb'>
    <ol>
      {items.map(({ href, name, id }, i) => (
        <li className={css['ds-breadcrumb__item']} key={id}>
          {i + 1 === items.length
            ? renderCurrentLocation(href, name)
            : renderLink(href, name)}
        </li>
      ))}
    </ol>
  </nav>
);

Breadcrumb.defaultProps = {
  items: {
    href: '',
  },
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      id: PropTypes.string,
    }),
  ),
};

export default Breadcrumb;
